<template>
  <div>
    <div>
      <DxDataGrid
        v-if="getCropsData.length > 1"
        id="edition"
        :data-source="getCropsData"
        :column-min-width="70"
        :column-auto-width="true"
        :allow-column-reordering="true"
        :show-borders="true"
        :show-column-lines="true"
        :show-row-lines="true"
        :row-alternation-enabled="true"
        :on-row-updating="updateCropsData"
        @exporting="onExporting"
      >
        <DxHeaderFilter :visible="true" />
        <DxEditing
          :allow-updating="true"
          mode="cell"
        />
        <DxStateStoring
          :enabled="true"
          type="localStorage"
          storage-key="DxCropsEdition"
        />
        <DxExport
          :enabled="true"
        />
        <DxPaging :page-size="10" />
        <DxSearchPanel
          :visible="false"
        />
        <DxColumn
          data-field="name"
          name="name"
          :caption="$t('Crop')"
          :allow-header-filtering="true"
          :allow-editing="false"
          :css-class="'bold'"
        />
        <DxColumn
          data-field="calendarFirstDate"
          name="calendarFirstDate"
          :caption="$t('calendarFirstDate')"
          :allow-header-filtering="false"
          :allow-editing="true"
          header-cell-template="tooltip"
          data-type="date"
          format="dd-MM"
        >
          <DxRequiredRule :message="$t('Required_message')" />
        </DxColumn>
        <DxColumn
          data-field="maxPerformance"
          name="maxPerformance"
          :caption="$t('maxPerformance')"
          :allow-header-filtering="false"
          :allow-editing="true"
          header-cell-template="tooltip"
        >
          <DxRequiredRule :message="$t('Required_message')" />
        </DxColumn>
        <DxColumn
          data-field="harvestYearJump"
          name="harvestYearJump"
          :caption="$t('harvestYearJump')"
          :allow-header-filtering="false"
          :allow-editing="true"
        />
        <DxColumn
          data-field="surfaceLimit"
          name="surfaceLimit"
          :caption="$t('surfaceLimit')"
          :allow-header-filtering="false"
          :allow-editing="true"
          header-cell-template="tooltip"
        >
          <DxRequiredRule :message="$t('Required_message')" />
        </DxColumn>
        <DxColumn
          data-field="totalIrrigationLimit"
          name="totalIrrigationLimit"
          :caption="$t('totalIrrigationLimit')"
          :allow-header-filtering="false"
          :visible="false"
          :allow-editing="true"
          header-cell-template="tooltip"
        >
          <DxRequiredRule :message="$t('Required_message')" />
        </DxColumn>
        <DxColumn
          data-field="cost"
          name="cost"
          :caption="$t('cost')"
          :allow-header-filtering="false"
          :allow-editing="true"
          header-cell-template="tooltip"
        >
          <DxRequiredRule :message="$t('Required_message')" />
        </DxColumn>
        <DxColumn
          data-field="cropAids"
          name="grants"
          :caption="$t('grants')"
          :allow-header-filtering="false"
          :allow-editing="true"
          header-cell-template="tooltip"
        >
          <DxRequiredRule :message="$t('Required_message')" />
        </DxColumn>
        <template #tooltip="{ data }">
          <span>
            <f7-link :tooltip="$t(`DxCrops_Helps_Tips_${data.column.name}`)">
              <i
                style="font-size: 20px"
                class="icon material-icons icon-tooltip if-md"
              >info</i>
            </f7-link>
            {{ data.column.caption }}
          </span>
        </template>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import {
  DxDataGrid,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxEditing,
  DxColumn,
  DxStateStoring,
  DxRequiredRule,
  DxHeaderFilter,
} from 'devextreme-vue/data-grid';
import moment from 'moment';

export default {
  name: 'DxCropsEdition',
  components: {
    DxDataGrid,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxEditing,
    DxColumn,
    DxStateStoring,
    DxRequiredRule,
    DxHeaderFilter,
  },
  props: {
    cropsData: {
      type: Object,
      default: () => {},
    },
    currentCrops: {
      type: Array,
      default: () => [],
    },
    barbechoData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    getCropsData() {
      const cropsDataFormated = [];
      const { barbechoData } = this;
      if (barbechoData.calendarFirstDate === '') {
        barbechoData.calendarFirstDate = moment('08-16', 'MM-DD').format('YYYY-MM-DD');
      }
      cropsDataFormated.push(barbechoData);
      for (const currentCrop of this.currentCrops) {
        if (typeof this.cropsData[currentCrop] !== 'undefined') {
          cropsDataFormated.push(this.cropsData[currentCrop]);
        }
      }
      return cropsDataFormated;
    },
  },
  methods: {
    onExporting(e) {
      this.$helpers.onExporting(e, 'HistoricalPrices', 'CropsHistoricalPrices.xlsx');
    },
    async updateCropsData(e) {
      const crop = await e.key;
      crop.calendarFirstDate = moment(crop.calendarFirstDate, 'YYYY/MM/DD').format('YYYY-MM-DD');
      if (crop === 'Barbecho') {
        this.setBarbechoData(crop);
      } else {
        this.updateCropData(crop);
      }
    },
    getRowByCrop(rows, cropID) {
      for (const row of rows) {
        if (cropID === row[this.$t('Crop')]) return row;
      }
      return [];
    },
    ...mapActions('Mopeco', ['setBarbechoData', 'updateCropData']),
  },
};
</script>
<style>
.bold {
  font-weight: bold;
}
</style>
